export class UserAccount {
  idUserAccount: number;
  idUser: number;
  type: string;
  title: string;

  constructor(
    idUserAccount: number,
    idUser: number,
    type: string,
    title: string,
  ) {
    this.idUserAccount = idUserAccount;
    this.idUser = idUser;
    this.type = type;
    this.title = title;
  }

  static fromRaw(raw: any): UserAccount {
    return new UserAccount(
      raw.idUserAccount,
      raw.idUser,
      String(raw.type),
      String(raw.title),
    );
  }

  clone(): UserAccount {
    return new UserAccount(
      this.idUserAccount,
      this.idUser,
      this.type,
      this.title,
    );
  }

  toPayload(): any {
    const payload: any = {
      idUser: this.idUser,
      type: this.type,
      title: this.title,
    };
    if (this.idUserAccount !== 0) {
      payload.idUserAccount = this.idUserAccount;
    }
    delete payload.idUser;
    if (this.type === '') {
      payload.type = null;
    }
    return payload;
  }
}
